/* eslint-disable i18next/no-literal-string -- const definitions are the source of truth */

/**
 * Shared lifecycle types for governed request workflows (access requests,
 * function-group requests). Mirrors {@code com.irian.iam.requestbase.api}
 * on the backend.
 *
 * Semantically-different workflows (rule-request approval, which is directly
 * set rather than computed from items) keep their own enums.
 */

export const RequestItemStatus = {
    PENDING_APPROVAL: 'PENDING_APPROVAL',
    APPROVED: 'APPROVED',
    REJECTED: 'REJECTED',
    FULFILLED: 'FULFILLED',
    CANCELLED: 'CANCELLED',
} as const;
export type RequestItemStatus = typeof RequestItemStatus[keyof typeof RequestItemStatus];

export const RequestStatus = {
    SUBMITTED: 'SUBMITTED',
    IN_PROGRESS: 'IN_PROGRESS',
    COMPLETED: 'COMPLETED',
    CANCELLED: 'CANCELLED',
} as const;
export type RequestStatus = typeof RequestStatus[keyof typeof RequestStatus];
